import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Search, Package } from "lucide-react";
import { toast } from "sonner";

export default function TrackOrder() {
  const [orderIdInput, setOrderIdInput] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    const cleanId = orderIdInput.trim().replace("#", "");
    if (!cleanId) {
      toast.error("Por favor, informe o código do pedido.");
      return;
    }

    setLoading(true);
    try {
      // API call to lookup the order by prefix or full UUID
      const response = await api.get(`/orders/${cleanId}`);
      // Redirect to the customer order status page using the full resolved UUID
      navigate(`/pedido/${response.data.id}`);
    } catch (err) {
      const msg = err.response?.data?.detail || "Pedido não encontrado. Verifique o código e tente novamente.";
      toast.error(typeof msg === "string" ? msg : "Pedido não encontrado.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24 sm:py-32">
      <div className="card-soft p-8 sm:p-10 text-center">
        <div className="w-16 h-16 rounded-full bg-gp-gradient-light mx-auto flex items-center justify-center mb-6">
          <Package className="w-8 h-8 text-[#1BB0CE]" />
        </div>
        
        <h1 className="font-quicksand text-2xl font-bold tracking-wide text-[#3d3d3d] mb-2">
          Acompanhar meu Pedido
        </h1>
        <p className="text-sm text-[#666] mb-8 leading-relaxed">
          Digite o código do seu pedido (ex: #D7C88FC1 ou o código completo) para verificar o status de pagamento e envio.
        </p>

        <form onSubmit={handleSearch} className="space-y-4">
          <label className="flex flex-col gap-2 text-left">
            <span className="text-xs font-quicksand font-bold text-[#3d3d3d]">Código do Pedido</span>
            <input
              type="text"
              placeholder="Ex: #D7C88FC1"
              value={orderIdInput}
              onChange={(e) => setOrderIdInput(e.target.value)}
              className="input-gp"
              required
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            className="btn-gp w-full flex items-center justify-center gap-2 mt-4"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Buscando...
              </>
            ) : (
              <>
                <Search className="w-4 h-4" />
                Buscar Pedido
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
